import z from "zod";

export const acceptMatchFormSchema = z.object({
  message: z.string().optional(),
});

export type AcceptMatchFormValues = z.infer<typeof acceptMatchFormSchema>;
